import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import ContextWrapper from 'components/templates/Wrappers/Sidebars/ContextWrapper/ContextWrapper';

const StyledDatabaseEntitySideBarWrapper = styled(ContextWrapper)`
  .EntitiesList {
    .DataList-list {
      overscroll-behavior: contain;
    }
  }
  ${ComponentStyles}
`;

StyledDatabaseEntitySideBarWrapper.propTypes = {
  theme: PropTypes.object
};

export default StyledDatabaseEntitySideBarWrapper;
